import React, { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { Container, Spinner } from 'react-bootstrap'; // Spinner from bootstrap
import Turnstile from 'react-turnstile';

const API_URL = process.env.REACT_APP_API_URL;
const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY;

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [turnstileToken, setTurnstileToken] = useState('');
  const [error, setError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(false);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValidEmail = emailRegex.test(email);

    if (!email || !isValidEmail || !turnstileToken) {
      setError(true);
      return;
    }

    setIsSubmitting(true); // Start loading

    try {
      const res = await fetch(`${API_URL}/auth/forgot`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, turnstileToken }),
      });

      const data = await res.json();
      toast.success(data.message);
    } catch (err) {
      toast.error('Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false); // Done loading
    }
  };

  return (
    <Container className="mt-5">
      <ToastContainer />
      <div className="home-page-wrapper">
        <div className="login-container">
          <h3>Forgot your password?</h3>
          <p>Enter your email and we'll send you a reset link.</p>
          <form onSubmit={handleSubmit}>
            <div className="input-wrapper">
              <input
                type="email"
                placeholder="you@example.com"
                className={`input-control mb-3 ${error && !email ? 'error' : ''}`}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={isSubmitting}
              />
              {error && (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) && (
                <span className="input-error">Please enter a valid email</span>
              )}
            </div>

            <div className="input-wrapper">
              <label className="input-label">Verify you're human</label>
              <Turnstile
                sitekey={TURNSTILE_SITE_KEY}
                onVerify={(token) => setTurnstileToken(token)}
                className="turnstile-wrapper"
              />
              {error && !turnstileToken && (
                <span className="input-error">Please complete the CAPTCHA</span>
              )}
            </div>

            <button
              className="btn btn-primary w-100 mt-3 d-flex align-items-center justify-content-center"
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Sending...
                </>
              ) : (
                'Send Reset Link'
              )}
            </button>
          </form>
        </div>
      </div>
    </Container>
  );
}
